import imageDe from '../images/de/sensotrend_connect_view_data.png';
import imageEn from '../images/en/sensotrend_connect_view_data.png';
import imageEs from '../images/es/sensotrend_connect_view_data.png';
import imageFi from '../images/fi/sensotrend_connect_view_data.png';
import imageFr from '../images/fr/sensotrend_connect_view_data.png';
import imageIt from '../images/it/sensotrend_connect_view_data.png';
import imageNo from '../images/no/sensotrend_connect_view_data.png';
import imageSv from '../images/sv/sensotrend_connect_view_data.png';

export const viewDataImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
